import { useTranslation } from 'react-i18next';
import './i18n';
import Home from "./pages/Home/Home.component";
import './App.css';

function App() {
  const { i18n } = useTranslation();

  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
